var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.superUser || _vm.permission)?_c('v-tab-item',{attrs:{"value":_vm.$route.path}},[_c('v-row',{staticClass:"pa-3 b-grey",attrs:{"no-gutters":""}},[(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.logo &&
                    _vm.storePermissions.settings.profile_attribute.logo)
            )?_c('v-col',{staticClass:"pr-3",attrs:{"cols":"12","md":"6"}},[_c('Logo')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.pin_display &&
                    _vm.storePermissions.settings.profile_attribute.pin_display)
            )?_c('v-col',{staticClass:"pl-3",attrs:{"cols":"12","md":"6"}},[_c('PinDisplay')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.pin_display_outside_operation_hours &&
                    _vm.storePermissions.settings.profile_attribute.pin_display_outside_operation_hours)
            )?_c('v-col',{staticClass:"pr-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('PinDisplayHours')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.thermal_printer &&
                    _vm.storePermissions.settings.profile_attribute.thermal_printer)
            )?_c('v-col',{staticClass:"pr-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('ThermalPrinter')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute
                    .business_information &&
                    _vm.storePermissions.settings.profile_attribute
                        .business_information)
            )?_c('v-col',{staticClass:"mt-6",attrs:{"cols":"12"}},[_c('BusinessInformation')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute
                    .hours_of_operation &&
                    _vm.storePermissions.settings.profile_attribute
                        .hours_of_operation)
            )?_c('v-col',{staticClass:"mt-6",attrs:{"cols":"12"}},[_c('OperationHours')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.invoicing &&
                    _vm.storePermissions.settings.profile_attribute.invoicing)
            )?_c('v-col',{staticClass:"pr-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('Invoicing')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.fast_payment &&
                    _vm.storePermissions.settings.profile_attribute
                        .fast_payment)
            )?_c('v-col',{staticClass:"pl-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('FastPayment')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.shopping_cart &&
                    _vm.storePermissions.settings.profile_attribute
                        .shopping_cart)
            )?_c('v-col',{staticClass:"pr-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('ShoppingCart')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.change_password &&
                    _vm.storePermissions.settings.profile_attribute
                        .change_password)
            )?_c('v-col',{staticClass:"pl-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('ChangePassword')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute
                    .redemption_settings &&
                    _vm.storePermissions.settings.profile_attribute
                        .redemption_settings)
            )?_c('v-col',{staticClass:"pr-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('RedemptionSettings')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute
                    .coupon_claim_days &&
                    _vm.storePermissions.settings.profile_attribute
                        .coupon_claim_days)
            )?_c('v-col',{staticClass:"pr-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('StoreCouponClaimValidDays')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.cash_registers &&
                    _vm.storePermissions.settings.profile_attribute.cash_registers)
            )?_c('v-col',{staticClass:"pl-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('CashRegisters')],1):_vm._e(),(
                _vm.superUser ||
                (_vm.permissions.settings.profile_attribute.store_settings &&
                    _vm.storePermissions.settings.profile_attribute.store_settings)
            )?_c('v-col',{staticClass:"pl-3 mt-6",attrs:{"cols":"12","md":"6"}},[_c('TransactionLimit')],1):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }